export default "__VITE_ASSET__Dkp3CVA___"